/* eslint-disable no-shadow */
/* eslint-disable import/no-cycle */

// import Vue from 'vue';
import ApiService from '@/services/api.service';
import { apiEndpoint } from '@/shared';
import { HttpError, PMSError, ValidationError } from '@/errors';

const endpoint = `${apiEndpoint}/explanation-box`;

const state = {
  explanationBoxes: null,
  explanationBox: null,
  pending: false,
  error: null,
  explanationBoxPending: false,
};

const getters = {
  explanationBoxes: (state) => state.explanationBoxes,
  explanationBox: (state) => state.explanationBox,
  explanationBoxPending: (state) => state.explanationBoxPending,
  error: (state) => state.error,
};

const mutations = {
  clearErrors(state) {
    state.error = null;
  },
  beforeExplanationBoxRequest(state) {
    state.error = null;
    state.explanationBoxPending = true;
  },
  afterExplanationBoxRequest(state) {
    state.explanationBoxPending = false;
  },
  explanationBox(state, data) {
    state.explanationBox = data;
  },
  explanationBoxes(state, data) {
    state.explanationBoxes = data;
  },
};

function handleApiError(commit, error) {
  const { status, data } = error.response;
  let err = error;
  switch (status) {
    case 400: // BadRequest
      err = new HttpError(status, data.message);
      break;
    case 409: // PMSError
      err = new PMSError(status, data.message);
      break;
    case 422:
      err = new ValidationError(status, data.message, data.errors);
      break;
    case 500:
      err = new Error(data.message);
      break;
    default:
      break;
  }
  // commit('update', err);
  throw err;
}

const actions = {
  async getExplanationBox({ commit }, id) {
    commit('beforeExplanationBoxRequest');
    try {
      const { data: explanationBox } = await ApiService.get(`${endpoint}/${id}`);
      commit('explanationBox', explanationBox.data);
      commit('afterExplanationBoxRequest');
      return explanationBox;
    } catch (error) {
      commit('afterExplanationBoxRequest');
      handleApiError(commit, error);
      return null;
    }
  },
  async createExplanationBox({ commit }, payload) {
    commit('beforeExplanationBoxRequest');
    try {
      const { data: explanationBox } = await ApiService.post(`${endpoint}`, payload);
      commit('explanationBox', explanationBox);
      commit('afterExplanationBoxRequest');
      return explanationBox;
    } catch (error) {
      commit('afterExplanationBoxRequest');
      handleApiError(commit, error);
      return null;
    }
  },
  async updateExplanationBox({ commit }, payload) {
    commit('beforeExplanationBoxRequest');
    try {
      const { data: explanationBox } = await ApiService.put(`${endpoint}`, payload);
      commit('afterExplanationBoxRequest');
      commit('explanationBox', explanationBox);
    } catch (error) {
      commit('afterExplanationBoxRequest');
      handleApiError(commit, error);
    }
  },
  async fetchExplanationBoxes({ commit }) {
    commit('beforeExplanationBoxRequest');
    try {
      const { data } = await ApiService.get(`${endpoint}`);
      commit('explanationBoxes', data.data);
      commit('afterExplanationBoxRequest');
      return data;
    } catch (error) {
      commit('afterExplanationBoxRequest');
      throw handleApiError(commit, error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
